/* eslint-disable camelcase */
import React, { Component } from 'react';
import styled from 'styled-components';

import { Button } from '../components/Button';
import { Input } from '../components/Input';

const InputWrapper = styled.div`
  width: 100%;
  display: flex;
  flex-wrap: wrap;

  > div {
    flex-basis: 49%;
    margin: 5px auto;
  }

  > button {
    margin: 20px 0;
  }
`;

export class MeasurementEdit extends Component {
  constructor(props) {
    super(props);
    this.state = {
      rl: props.element ? props.element.rl : '',
      rw: props.element ? props.element.rw : '',
      qd: props.element ? props.element.qd : '',
      srt: props.element ? props.element.srt : '',
      coordinates: props.element ? props.element.coordinates : '',
      location: props.element ? props.element.location : '',
      street: props.element ? props.element.street : '',
      line: props.element ? props.element.line : '',
      date: props.element ? props.element.date : '',
      material_type: props.element ? props.element.material_type : '',
      serial_number: props.element ? props.element.serial_number : '',
      database: props.element ? props.element.database : '',
      air_humidity: props.element ? props.element.air_humidity : '',
      air_temperature: props.element ? props.element.air_temperature : '',
      application_temperature: props.element ? props.element.application_temperature : '',
      application_humidity: props.element ? props.element.application_humidity : '',
      surface_application_temperature: props.element ? props.element.surface_application_temperature : '',
      surface_application_humidity: props.element ? props.element.surface_application_humidity : '',
      drying_time: props.element ? props.element.drying_time : '',
      line_width: props.element ? props.element.line_width : '',
      direction: props.element ? props.element.direction : '',
      position: props.element ? props.element.position : '',
      section: props.element ? props.element.section : '',
      marking_material: props.element ? props.element.marking_material : '',
      grit_beads: props.element ? props.element.grit_beads : '',
      grit_type: props.element ? props.element.grit_type : '',
      grit_mixture: props.element ? props.element.grit_mixture : '',
      grit_number: props.element ? props.element.grit_number : '',
      grip_product: props.element ? props.element.grip_product : '',
      grip_type: props.element ? props.element.grip_type : '',
      grip_manufacturer: props.element ? props.element.grip_manufacturer : '',
      grip_number: props.element ? props.element.grip_number : '',
      remarks: props.element ? props.element.remarks : '',
      picture: props.element ? props.element.picture : '',
      user_name: props.element ? props.element.user_name : '',
      job: props.element ? props.element.job : '',
      manufacturer: props.element ? props.element.manufacturer : '',
      applicator: props.element ? props.element.applicator : '',
      marking_machine: props.element ? props.element.marking_machine : '',
      application_note: props.element ? props.element.application_note : '',
      subsoil_type: props.element ? props.element.subsoil_type : '',
      substrate_pretreatment: props.element ? props.element.substrate_pretreatment : '',
      dry_film_thickness: props.element ? props.element.dry_film_thickness : '',
      harder_type: props.element ? props.element.harder_type : '',
      pearl_and_batch_mark: props.element ? props.element.pearl_and_batch_mark : '',
      marking_material_and_batch: props.element ? props.element.marking_material_and_batch : '',
      marking_type: props.element ? props.element.marking_type : '',
      dtv_sv_mark: props.element ? props.element.dtv_sv_mark : '',
      snowplow_inserts: props.element ? props.element.snowplow_inserts : '',
      roadway_width: props.element ? props.element.roadway_width : '',
      color: props.element ? props.element.color : '',
      application_date: props.element ? props.element.application_date : '',
    };

    this.rlChange = this.rlChange.bind(this);
    this.rwChange = this.rwChange.bind(this);
    this.qdChange = this.qdChange.bind(this);
    this.srtChange = this.srtChange.bind(this);
    this.coordinatesChange = this.coordinatesChange.bind(this);
    this.locationChange = this.locationChange.bind(this);
    this.streetChange = this.streetChange.bind(this);
    this.lineChange = this.lineChange.bind(this);
    this.dateChange = this.dateChange.bind(this);
    this.materialTypeChange = this.materialTypeChange.bind(this);
    this.serialTumberChange = this.serialTumberChange.bind(this);
    this.databaseChange = this.databaseChange.bind(this);
    this.airHumidityChange = this.airHumidityChange.bind(this);
    this.airTemperatureChange = this.airTemperatureChange.bind(this);
    this.applicationTemperatureChange = this.applicationTemperatureChange.bind(this);
    this.applicationHumidityChange = this.applicationHumidityChange.bind(this);
    this.surfaceApplicationTemperatureChange = this.surfaceApplicationTemperatureChange.bind(this);
    this.surfaceApplicationHumidityChange = this.surfaceApplicationHumidityChange.bind(this);
    this.dryingTimeChange = this.dryingTimeChange.bind(this);
    this.lineWidthChange = this.lineWidthChange.bind(this);
    this.directionChange = this.directionChange.bind(this);
    this.positionChange = this.positionChange.bind(this);
    this.sectionChange = this.sectionChange.bind(this);
    this.markingMaterialChange = this.markingMaterialChange.bind(this);
    this.gritBeadsChange = this.gritBeadsChange.bind(this);
    this.gritTypeChange = this.gritTypeChange.bind(this);
    this.gritMixtureChange = this.gritMixtureChange.bind(this);
    this.gritNumberChange = this.gritNumberChange.bind(this);
    this.gripProductChange = this.gripProductChange.bind(this);
    this.gripTypeChange = this.gripTypeChange.bind(this);
    this.gripManufacturerChange = this.gripManufacturerChange.bind(this);
    this.gripNumberChange = this.gripNumberChange.bind(this);
    this.remarksChange = this.remarksChange.bind(this);
    this.pictureChange = this.pictureChange.bind(this);
    this.userNameChange = this.userNameChange.bind(this);
    this.jobChange = this.jobChange.bind(this);
    this.manufacturerChange = this.manufacturerChange.bind(this);
    this.applicatorChange = this.applicatorChange.bind(this);
    this.markingMachineChange = this.markingMachineChange.bind(this);
    this.applicationNoteChange = this.applicationNoteChange.bind(this);
    this.subsoilTypeChange = this.subsoilTypeChange.bind(this);
    this.substratePretreatmentChange = this.substratePretreatmentChange.bind(this);
    this.dryFilmThicknessChange = this.dryFilmThicknessChange.bind(this);
    this.harderTypeChange = this.harderTypeChange.bind(this);
    this.pearlAndBatchMarkChange = this.pearlAndBatchMarkChange.bind(this);
    this.markingMaterialAndBatchChange = this.markingMaterialAndBatchChange.bind(this);
    this.markingTypeChange = this.markingTypeChange.bind(this);
    this.dtvSvMarkChange = this.dtvSvMarkChange.bind(this);
    this.snowplowInsertsChange = this.snowplowInsertsChange.bind(this);
    this.roadwayWidthChange = this.roadwayWidthChange.bind(this);
    this.colorChange = this.colorChange.bind(this);
    this.applicationDateChange = this.applicationDateChange.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);
  }

  rlChange(e) {
    this.setState({
      rl: e.target.value,
    });
  }
  rwChange(e) {
    this.setState({
      rw: e.target.value,
    });
  }
  qdChange(e) {
    this.setState({
      qd: e.target.value,
    });
  }
  srtChange(e) {
    this.setState({
      srt: e.target.value,
    });
  }
  coordinatesChange(e) {
    this.setState({
      coordinates: e.target.value,
    });
  }
  locationChange(e) {
    this.setState({
      location: e.target.value,
    });
  }
  streetChange(e) {
    this.setState({
      street: e.target.value,
    });
  }
  lineChange(e) {
    this.setState({
      line: e.target.value,
    });
  }
  dateChange(e) {
    this.setState({
      date: e.target.value,
    });
  }
  materialTypeChange(e) {
    this.setState({
      material_type: e.target.value,
    });
  }
  serialTumberChange(e) {
    this.setState({
      serial_number: e.target.value,
    });
  }
  databaseChange(e) {
    this.setState({
      database: e.target.value,
    });
  }
  airHumidityChange(e) {
    this.setState({
      air_humidity: e.target.value,
    });
  }
  airTemperatureChange(e) {
    this.setState({
      air_temperature: e.target.value,
    });
  }
  applicationTemperatureChange(e) {
    this.setState({
      application_temperature: e.target.value,
    });
  }
  applicationHumidityChange(e) {
    this.setState({
      application_humidity: e.target.value,
    });
  }
  surfaceApplicationTemperatureChange(e) {
    this.setState({
      surface_application_temperature: e.target.value,
    });
  }
  surfaceApplicationHumidityChange(e) {
    this.setState({
      surface_application_humidity: e.target.value,
    });
  }
  dryingTimeChange(e) {
    this.setState({
      drying_time: e.target.value,
    });
  }
  lineWidthChange(e) {
    this.setState({
      line_width: e.target.value,
    });
  }
  directionChange(e) {
    this.setState({
      direction: e.target.value,
    });
  }
  positionChange(e) {
    this.setState({
      position: e.target.value,
    });
  }
  sectionChange(e) {
    this.setState({
      section: e.target.value,
    });
  }
  markingMaterialChange(e) {
    this.setState({
      marking_material: e.target.value,
    });
  }
  gritBeadsChange(e) {
    this.setState({
      grit_beads: e.target.value,
    });
  }
  gritTypeChange(e) {
    this.setState({
      grit_type: e.target.value,
    });
  }
  gritMixtureChange(e) {
    this.setState({
      grit_mixture: e.target.value,
    });
  }
  gritNumberChange(e) {
    this.setState({
      grit_number: e.target.value,
    });
  }
  gripProductChange(e) {
    this.setState({
      grip_product: e.target.value,
    });
  }
  gripTypeChange(e) {
    this.setState({
      grip_type: e.target.value,
    });
  }
  gripManufacturerChange(e) {
    this.setState({
      grip_manufacturer: e.target.value,
    });
  }
  gripNumberChange(e) {
    this.setState({
      grip_number: e.target.value,
    });
  }
  remarksChange(e) {
    this.setState({
      remarks: e.target.value,
    });
  }
  pictureChange(e) {
    this.setState({
      picture: e.target.value,
    });
  }
  userNameChange(e) {
    this.setState({
      user_name: e.target.value,
    });
  }
  jobChange(e) {
    this.setState({
      job: e.target.value,
    });
  }
  manufacturerChange(e) {
    this.setState({
      manufacturer: e.target.value,
    });
  }
  applicatorChange(e) {
    this.setState({
      applicator: e.target.value,
    });
  }
  markingMachineChange(e) {
    this.setState({
      marking_machine: e.target.value,
    });
  }
  applicationNoteChange(e) {
    this.setState({
      application_note: e.target.value,
    });
  }
  subsoilTypeChange(e) {
    this.setState({
      subsoil_type: e.target.value,
    });
  }
  substratePretreatmentChange(e) {
    this.setState({
      substrate_pretreatment: e.target.value,
    });
  }
  dryFilmThicknessChange(e) {
    this.setState({
      dry_film_thickness: e.target.value,
    });
  }
  harderTypeChange(e) {
    this.setState({
      harder_type: e.target.value,
    });
  }
  pearlAndBatchMarkChange(e) {
    this.setState({
      pearl_and_batch_mark: e.target.value,
    });
  }
  markingMaterialAndBatchChange(e) {
    this.setState({
      marking_material_and_batch: e.target.value,
    });
  }
  markingTypeChange(e) {
    this.setState({
      marking_type: e.target.value,
    });
  }
  dtvSvMarkChange(e) {
    this.setState({
      dtv_sv_mark: e.target.value,
    });
  }
  snowplowInsertsChange(e) {
    this.setState({
      snowplow_inserts: e.target.value,
    });
  }
  roadwayWidthChange(e) {
    this.setState({
      roadway_width: e.target.value,
    });
  }
  colorChange(e) {
    this.setState({
      color: e.target.value,
    });
  }
  applicationDateChange(e) {
    this.setState({
      application_date: e.target.value,
    });
  }
  handleSubmit() {
    this.props.onSave(this.state);
  }

  render() {
    const {
      rl,
      rw,
      qd,
      srt,
      coordinates,
      location,
      street,
      line,
      date,
      material_type,
      serial_number,
      database,
      air_humidity,
      air_temperature,
      application_temperature,
      application_humidity,
      surface_application_temperature,
      surface_application_humidity,
      drying_time,
      line_width,
      direction,
      position,
      section,
      marking_material,
      grit_beads,
      grit_type,
      grit_mixture,
      grit_number,
      grip_product,
      grip_type,
      grip_manufacturer,
      grip_number,
      remarks,
      picture,
      user_name,
      job,
      manufacturer,
      applicator,
      marking_machine,
      application_note,
      subsoil_type,
      substrate_pretreatment,
      dry_film_thickness,
      harder_type,
      pearl_and_batch_mark,
      marking_material_and_batch,
      marking_type,
      dtv_sv_mark,
      snowplow_inserts,
      roadway_width,
      color,
      application_date,
    } = this.state;

    return (
      <InputWrapper>
        <Input
          onChange={this.rlChange}
          placeholder='rl'
          value={rl || ''}
        />
        <Input
          onChange={this.rwChange}
          placeholder='rw'
          value={rw || ''}
        />
        <Input
          onChange={this.qdChange}
          placeholder='qd'
          value={qd || ''}
        />
        <Input
          onChange={this.srtChange}
          placeholder='srt'
          value={srt || ''}
        />
        <Input
          onChange={this.coordinatesChange}
          placeholder='coordinates'
          value={coordinates || ''}
        />
        <Input
          onChange={this.locationChange}
          placeholder='location'
          value={location || ''}
        />
        <Input
          onChange={this.streetChange}
          placeholder='street'
          value={street || ''}
        />
        <Input
          onChange={this.lineChange}
          placeholder='line'
          value={line || ''}
        />
        <Input
          onChange={this.dateChange}
          placeholder='date'
          type="date"
          value={date || ''}
        />
        <Input
          onChange={this.materialTypeChange}
          placeholder='material_type'
          value={material_type || ''}
        />
        <Input
          onChange={this.serialTumberChange}
          placeholder='serial_number'
          value={serial_number || ''}
        />
        <Input
          onChange={this.databaseChange}
          placeholder='database'
          value={database || ''}
        />
        <Input
          onChange={this.airHumidityChange}
          placeholder='air_humidity'
          value={air_humidity || ''}
        />
        <Input
          onChange={this.airTemperatureChange}
          placeholder='air_temperature'
          value={air_temperature || ''}
        />
        <Input
          onChange={this.applicationTemperatureChange}
          placeholder='application_temperature'
          value={application_temperature || ''}
        />
        <Input
          onChange={this.applicationHumidityChange}
          placeholder='application_humidity'
          value={application_humidity || ''}
        />
        <Input
          onChange={this.surfaceApplicationTemperatureChange}
          placeholder='surface_application_temperature'
          value={surface_application_temperature || ''}
        />
        <Input
          onChange={this.surfaceApplicationHumidityChange}
          placeholder='surface_application_humidity'
          value={surface_application_humidity || ''}
        />
        <Input
          onChange={this.dryingTimeChange}
          placeholder='drying_time'
          value={drying_time || ''}
        />
        <Input
          onChange={this.lineWidthChange}
          placeholder='line_width'
          value={line_width || ''}
        />
        <Input
          onChange={this.directionChange}
          placeholder='direction'
          value={direction || ''}
        />
        <Input
          onChange={this.positionChange}
          placeholder='position'
          value={position || ''}
        />
        <Input
          onChange={this.sectionChange}
          placeholder='section'
          value={section || ''}
        />
        <Input
          onChange={this.markingMaterialChange}
          placeholder='marking_material'
          value={marking_material || ''}
        />
        <Input
          onChange={this.gritBeadsChange}
          placeholder='grit_beads'
          value={grit_beads || ''}
        />
        <Input
          onChange={this.gritTypeChange}
          placeholder='grit_type'
          value={grit_type || ''}
        />
        <Input
          onChange={this.gritMixtureChange}
          placeholder='grit_mixture'
          value={grit_mixture || ''}
        />
        <Input
          onChange={this.gritNumberChange}
          placeholder='grit_number'
          value={grit_number || ''}
        />
        <Input
          onChange={this.gripProductChange}
          placeholder='grip_product'
          value={grip_product || ''}
        />
        <Input
          onChange={this.gripTypeChange}
          placeholder='grip_type'
          value={grip_type || ''}
        />
        <Input
          onChange={this.gripManufacturerChange}
          placeholder='grip_manufacturer'
          value={grip_manufacturer || ''}
        />
        <Input
          onChange={this.gripNumberChange}
          placeholder='grip_number'
          value={grip_number || ''}
        />
        <Input
          onChange={this.remarksChange}
          placeholder='remarks'
          value={remarks || ''}
        />
        <Input
          onChange={this.pictureChange}
          placeholder='picture'
          value={picture || ''}
        />
        <Input
          onChange={this.userNameChange}
          placeholder='user_name'
          value={user_name || ''}
        />
        <Input
          onChange={this.jobChange}
          placeholder='job'
          value={job || ''}
        />
        <Input
          onChange={this.manufacturerChange}
          placeholder='manufacturer'
          value={manufacturer || ''}
        />
        <Input
          onChange={this.applicatorChange}
          placeholder='applicator'
          value={applicator || ''}
        />
        <Input
          onChange={this.markingMachineChange}
          placeholder='marking_machine'
          value={marking_machine || ''}
        />
        <Input
          onChange={this.applicationNoteChange}
          placeholder='application_note'
          value={application_note || ''}
        />
        <Input
          onChange={this.subsoilTypeChange}
          placeholder='subsoil_type'
          value={subsoil_type || ''}
        />
        <Input
          onChange={this.substratePretreatmentChange}
          placeholder='substrate_pretreatment'
          value={substrate_pretreatment || ''}
        />
        <Input
          onChange={this.dryFilmThicknessChange}
          placeholder='dry_film_thickness'
          value={dry_film_thickness || ''}
        />
        <Input
          onChange={this.harderTypeChange}
          placeholder='harder_type'
          value={harder_type || ''}
        />
        <Input
          onChange={this.pearlAndBatchMarkChange}
          placeholder='pearl_and_batch_mark'
          value={pearl_and_batch_mark || ''}
        />
        <Input
          onChange={this.markingMaterialAndBatchChange}
          placeholder='marking_material_and_batch'
          value={marking_material_and_batch || ''}
        />
        <Input
          onChange={this.markingTypeChange}
          placeholder='marking_type'
          value={marking_type || ''}
        />
        <Input
          onChange={this.dtvSvMarkChange}
          placeholder='dtv_sv_mark'
          value={dtv_sv_mark || ''}
        />
        <Input
          onChange={this.snowplowInsertsChange}
          placeholder='snowplow_inserts'
          value={snowplow_inserts || ''}
        />
        <Input
          onChange={this.roadwayWidthChange}
          placeholder='roadway_width'
          value={roadway_width || ''}
        />
        <Input
          onChange={this.colorChange}
          placeholder='color'
          value={color || ''}
        />
        <Input
          onChange={this.applicationDateChange}
          placeholder='application_date'
          type="date"
          value={application_date || ''}
        />
        <Button
          block
          onClick={this.handleSubmit}
        >
          CREATE
        </Button>
      </InputWrapper>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/MeasurementEdit.js